import React, {useState} from "react";

const useModal = ({component}) => {

  const [refresh, setRefresh] = useState(1)
  const [showModal, setShowModal] = useState(false);

  const [body, setBody] = useState(null);

  const someAction = (args) => {
    setShowModal(true)
    //setBody(component)
    setBody(React.cloneElement(component, {...args}))
  }
  const onCloseModal = () => {
    setShowModal(false)
    setRefresh(refresh + 1)
  }

  const wrapper = {
    show: showModal,
    onHide: onCloseModal,
    body: body
  }

  return {wrapper, refresh, someAction}
}

export default useModal

